<template>
  <div style="display: flex; flex-direction: column; flex: 1">
    <div class="favourites_block_holder" style="display: flex; flex-direction: column">
      <div id="favourites_list" class="" style="flex: 1; overflow-y: scroll">
        <div v-for="athlete in filteredAthletes" v-bind:key="athlete.id">
          <div class="favourites_block row nomargin" >
            <div class="col-sm-12">
              <span class="position">{{athlete.position}}</span>
              <span v-if="athlete.team_id"><img style="height:15px; width:15px;" v-bind:src="getFlag(athlete)"> {{athlete.team.name}}</span>
              <span v-else-if="athlete.first_name"><img style="height:15px; width:15px;" v-bind:src="getFlag(athlete)"> {{athlete.first_name}} {{athlete.last_name}}</span>
              <span class="pull-right">
              <span class="time">{{time(athlete)}}</span>
              <i class="fav" v-on:click="toggleFavourite(athlete)">
                <favIcon v-if="athlete.first_name" v-bind:gender="athlete.gender"
                         v-bind:aid="athlete.id"/>
              </i>
            </span>
            <div class="distance_tracker">
              <progressbar v-if="!athlete.isFinished" v-bind:current-distance="athlete.properties.distance" v-bind:total-distance="raceDist" />
              <div v-else class="distance_tracker"><center><span class="withdrawn" id="statuspane">FINISHED</span></center></div>
            </div>
            <table>
              <tbody>
                <tr>
                  <td><span class="info_block_text elevation">{{athlete.properties.elevation}} m</span><br><span class="info_block_text_small">ELEVATION</span></td>
                  <td><span class="info_block_text elevation"></span><br><span class="info_block_text_small"></span></td>
                  <td><span class="info_block_text elevation"></span><br><span class="info_block_text_small"></span></td>
                  <td><span class="more"><i class="icon-more" v-on:click="log(athlete)"></i></span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="gap_holder" v-if="athlete !== filteredAthletes[filteredAthletes.length - 1]">
          <center>
            <div class="gap">
              GAP <span class="gap_distance"> {{ gap(athlete.id, filteredAthletes[filteredAthletes.indexOf(athlete) + 1].id) }}</span>
            </div>
          </center>
        </div>
        </div>
    </div>
  </div>
  </div>
</template>
<style>
#favourites_list::-webkit-scrollbar{
  width:8px;
}
</style>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import progressbar from './athlete/progressbar'
import favIcon from './favicon'
export default{
  data: function () {
    return {
      runningTime: {},
      runningTimeUTC: {}
    }
  },
  components: {
    favIcon,
    progressbar
  },
  computed: {
    ...mapGetters({
      mobile: 'mobile',
      raceDist: 'routeDistance',
      favourites: 'favourites',
      getAthletes: 'athletes',
      starttime: 'starttime',
      currentTime: 'currentTime',
      races: 'races',
      sortedAthletes: 'sortedAthletes'
    }),
    filteredAthletes: function () {
      return this.sortedAthletes.filter(athlete => {
        if (typeof (athlete) !== 'undefined') {
          if (this.favourites.indexOf(athlete.id) >= 0) {
            return athlete
          } else if (this.favourites.indexOf(athlete.team_id) >= 0) {
            return athlete
          }
        }
      })
    },
    leaderboardheight: function () {
      if (this.mobile) {
        let h = window.innerHeight - 70 - 50 - 60
        return {
          height: h + 'px'
        }
      } else {
        let h = window.innerHeight - 70 - 58 - 53
        return {
          width: '98%',
          'margin-left': '1%',
          height: h + 'px'
        }
      }
    }
  },
  mounted () {
    setInterval(this.updateDateTime, 1000)
  },
  methods: {
    gap: function (id, id2) {
      let time
      if (this.getAthletes[id].isFinished && this.getAthletes[id2].isFinished) {
        time = moment.utc(this.getAthletes[id2].properties.duration - this.getAthletes[id].properties.duration, 'X').format('HH:mm:ss')
      } else {
        let distance = this.getAthletes[id].properties.distance - this.getAthletes[id2].properties.distance
        let speed = (this.getAthletes[id2].properties.distance / this.getAthletes[id2].properties.duration).toFixed(2)
        time = moment.utc(distance / speed, 'X')
        time = time.isValid() ? time.format('HH:mm:ss') : ''
      }
      return time
    },
    updateDateTime () {
      for (var key in this.getAthletes) {
        // let time = moment().unix() - moment.utc(this.getAthletes[key].race_start).unix()
        let dur = moment.duration(this.getAthletes[key].duration, 'seconds')
        this.$set(this.runningTimeUTC, key, dur)
        this.$set(this.runningTime, key, Math.floor(dur.asHours()) + ':' + ((dur.minutes() < 10) ? '0' + dur.minutes() : dur.minutes()))
      }
    },
    distance: function (ath) {
      if (parseInt(ath.isFinished) === 1 || (typeof (ath.status) === 'undefined') || ath.status === null) {
        return (ath.distance / 1000.0).toFixed(1) + ' km'
      } else {
        return '-'
      }
    },
    time: function (ath) {
      if (parseInt(ath.isFinished) === 1) {
        return this.toHHMMSS(ath.properties.duration)
      } else if ((typeof (ath.status) === 'undefined') || ath.status === null) {
        return this.runningTime[ath.race_athlete_id]
      } else if (ath.status === '2') {
        return ' WD '
      } else if (ath.status === '3') {
        return ' DNS '
      }
    },
    getFlag: function (ath) {
      return ath.country_code === null ? '' : 'https://app.sportraxs.com/images/svg/' + ath.country_code.toLowerCase() + '.svg'
    },
    log: function (ath) {
      if (typeof (ath.first_name) !== 'undefined') {
        if (this.mobile) {
          this.$router.push({name: 'mathlete', params: { id: ath.id }})
        } else {
          this.$router.push({name: 'athlete', params: { id: ath.id }})
        }
      } else if (typeof (ath.team_name) !== 'undefined') {
        if (this.mobile) {
          this.$router.push({name: 'mathlete', params: { id: ath.team_id }})
        } else {
          this.$router.push({name: 'athlete', params: { id: ath.team_id }})
        }
      }
    },
    toggleFavourite: function (ath) {
      if (typeof (ath.id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete remove: ' + ath.id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete add: ' + ath.id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.id)
        }
      } else if (typeof (ath.team_id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.team_id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team remove: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.team_id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team add: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.team_id)
        }
      }
    },
    toHHMMSS: function (secs) {
      var secNum = parseInt(secs, 10) // don't forget the second param
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = secNum - (hours * 3600) - (minutes * 60)
      if ((minutes < 10)) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      if (hours < 10) {
        hours = '' + hours
      }
      var time
      if (hours === '0') {
        time = '0:' + minutes + ':' + seconds
      } else {
        time = hours + ':' + minutes + ':' + seconds
      }
      return time
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/following.vue